import styled from 'styled-components';
import { Colors, BREAK_POINTS } from '@origin-digital/style-guide';

export const HMCContainer = styled.div`
  background-color: ${Colors.GREY4};
  width: 100vw;
  position: relative;

  [class^='Link__LinkChevron']:hover {
    svg {
      margin-left: -4px;
    }
    span {
      margin-left: 4px;
    }
  }
`;

export const StyledModal = styled.div`
  [data-id='modal'] {
    max-height: none;
    height: 100vh;
    padding: 0;
    border: none;
  }

  [class^='Modal__Backdrop'] {
    z-index: 1001;
  }

  [class^='Modal__Content'] {
    overflow-y: auto;
  }

  [class^='Modal__CloseButton'] {
    z-index: 1;
  }

  [class^='Modal__CloseButton'] {
    @media screen and (max-width: ${BREAK_POINTS.Max.MD}) {
      top: 20px;
    }
    @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
      &:before {
        content: 'Close';
        font-size: 12px;
        line-height: 22px;
        color: ${Colors.RED};
      }
    }
  }
`;

export const PromptContainer = styled.div`
  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    text-align: center;
  }
`;

export const Prompt = styled.div`
  margin-bottom: 8px;

  & > *:first-child {
    margin-bottom: 16px !important;
    text-align: left;
  }

  .recommended h3 {
    font-weight: 500;
    & > span {
      font-weight: 600;
    }
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    display: inline-flex;
    justify-content: space-apart;
    align-items: center;

    & > *:first-child {
      margin-bottom: 0 !important;
      margin-right: 16px;
    }
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    max-width: 796px;
    & > *:first-child {
      font-size: 20px;
      line-height: 26px;
    }
  }
`;

export const Disclaimer = styled.div`
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  background-color: ${Colors.GREY8};
`;
